module.exports = __webpack_public_path__ + "img/file-search-03.36d29b7f.svg";